//import * as ol from 'openlayers';   // AWH TODO: remove all OL code from cms_view_view and make OL calls directly into the library from here

import {
    VectorLayer,
    VectorSource,
    ClusterSource,
    Style,
    Circle,
    Stroke,
    Fill,
    Text,
    LineString,
    GeomPoint,
    Feature,
    proj
} from '../../openlayers/ol-bridge';

import { AssetCollection } from "../../assets/Asset";
import { Configuration } from "../../Configuration";
import { exists } from "../../utils";
import { FindingCollection } from "../../Findings";
import { get_state, State, did_any_change } from "../../redux/State";
import { Id_asset, Id_finding, Id_workorder } from "../../api/Identifiers";
import { Keys } from "../../redux/Datastore";
import { AttachmentCollection } from "../../Attachment";
import { Drawing } from "../../drawings/Drawing";
import { AttachmentUi } from "../attachment_ui";
import { Rectangle } from "../../Rectangle";
import { MapFeaturesCollection } from "../../MapFeaturesCollection";
import { MapFeature } from "../../MapFeature";
import { WorkordersCollection } from "../../workorders/WorkordersCollection";
import { Workorder } from "../../workorders/Workorder";

let _the_map: any = null;  // the map object
let _clustered_features_layer: any = null;
let _unclustered_features_layer: any = null;
let _the_map_features_layer: any = null;
let _the_lines_layer: any = null;

let FEATURES_LAYER_ZINDEX = 200;
let CALLOUTLINES_LAYER_ZINDEX = 100;

let _settings: any = {
    width: 16384,
    height: 16384,
    minZoom: 0,
    maxZoom: 6,
    tileSize: 256,
    maxResolution: 16,
    minResolution: 0.25,
    initialZoom: 1,
};

_settings.extent = [0, 0, _settings.width, _settings.height];

export function map_area_initialize(the_map: any, the_map_layers: any) {
    _the_map = the_map;
    _settings.projection = new proj.Projection({
        code: null,
        units: "pixels",
        extent: _settings.extent
    });

    _the_map.getView().on("change:resolution", on_resolution_changed);
}

function on_resolution_changed() {
    let view_is_close_up = _the_map.getView().getZoom() > 4;
    remove_map_layer(_the_lines_layer);
    if (view_is_close_up) {
        add_map_layer(_the_lines_layer);
    }

    let correct_features_layer = null;
    if (get_state().enabled_feature_cluster) {
        //add cluster toggle here no need for above call if cluster is disabled!!
        if (view_is_close_up) {
            correct_features_layer = _unclustered_features_layer;
        } else {
            correct_features_layer = _clustered_features_layer;
        }
    } else {
        correct_features_layer = _unclustered_features_layer;
    }

    if (_the_map_features_layer != correct_features_layer) {
        remove_map_layer(_the_map_features_layer);
        _the_map_features_layer = correct_features_layer;
        _the_map.addLayer(_the_map_features_layer);
    }
}


export function get_current_view_port_map(): Rectangle {
    let num: number[] = _the_map.getView().calculateExtent(_the_map.getSize());
    let zoom: number = _the_map.getView().getZoom();
    if (zoom == 1) {
        num[2] = num[2] - 8000;
    }
    else if (zoom == 2) {
        num[2] = num[2] - 4000;
    }
    else if (zoom == 3) {
        num[2] = num[2] - 2000;
    }
    else if (zoom == 4) {
        num[2] = num[2] - 1000;
    }
    else if (zoom == 5) {
        num[2] = num[2] - 500;
    }
    else if (zoom == 6) {
        num[2] = num[2] - 250;
    }
    return Rectangle.build_from_numbers(num[0], num[1], num[2], num[3]);
}

function _make_unclustered_layer(ol_features_collection: any /* : ol.Collection */) {
    return new VectorLayer({
        zIndex: FEATURES_LAYER_ZINDEX,
        source: new VectorSource({
            features: ol_features_collection,
            wrapX: false,
            noWrap: true,
            projection: _settings.projection,
            //     extent: settings.extent
            minResolution: _settings.minResolution,
            maxResolution: _settings.maxResolution,
        })
    });
}

function _make_clustered_layer(ol_features_collection: any /* : ol.Collection */) {

    var distance = Configuration.cluster_distance;

    var icons_source = new VectorSource({
        features: ol_features_collection,
    });

    var clusterSource = new ClusterSource({
        distance: distance,
        source: icons_source,
    });
    let styleCache: any = {};
    return new VectorLayer({
        source: clusterSource,
        zIndex:FEATURES_LAYER_ZINDEX,
        style: function (feature: any) {
            var size = feature.get("features").length;
            // if size is 1, show the icon
            if (size == 1) {
                return feature.get("features")[0].getStyle();
            }
            // also, if zoom level is 5 or 6, do not cluster
            var style = styleCache[size];
            if (!style) {
                style = new Style({
                    image: new Circle({
                        radius: 10,
                        stroke: new Stroke({
                            color: "#fff",
                        }),
                        fill: new Fill({
                            color: "#3399CC",
                        }),
                    }),
                    text: new Text({
                        text: size.toString(),
                        fill: new Fill({
                            color: "#fff",
                        }),
                    }),
                });
                styleCache[size] = style;
            }
            return style;
        }
    });
}


function _make_line_layer(map_features_collection: MapFeaturesCollection) {
    //linestring
    let line_string_style = new Style({
        stroke: new Stroke({
            color: "#f6891e",  // orange
            width: 5,
        }),
    });
    var ol_features: any[] = [];  // array of Feature objects
    map_features_collection.as_array.forEach((value: MapFeature) => {
        if (value.is_delustered) {
            var geometry = new LineString([value.adj_cluster_coords.as_array, value.adj_coords.as_array]);
            let ol_feature = new Feature({
                geometry: geometry,
                name: "Line",
            });

            ol_feature.setStyle(line_string_style);
            ol_features.push(ol_feature);

            // endpoint


            let end_point_feature = new Feature({
                geometry: new GeomPoint(value.adj_coords.as_array, "XY"),
            });
        
            end_point_feature.setStyle(
                new Style({
                    image: new Circle({
                        radius: 7,
                        // stroke: new Stroke({
                        //     color: '#fff',
                        // }),
                        fill: new Fill({
                            // color: '#3399CC',
                            color: "#f6891e",  // orange
                        }),
                    })
                }));

            ol_features.push(end_point_feature);
        }
    });
    // ol_features.forEach((ol_feature:any) => {
    // });
    var source = new VectorSource({
        features: ol_features
    });
    return new VectorLayer({
        zIndex: CALLOUTLINES_LAYER_ZINDEX,
        source: source
    });
}


function remove_map_layer(some_layer: any){
    if (exists(some_layer)) {
        _the_map.removeLayer(some_layer);
    }
}


function add_map_layer(some_layer: any){
    if (exists(some_layer)) {
        _the_map.addLayer(some_layer);
    }
}


`
This function ensures that the assets and workorders that are displayed on the
map match the assets and workorders that are marked as selected in the state.
`;
export function map_redraw_layers(force_reload?: boolean) {
    // awh todo - relocate the content of the map_redraw_layers function in cms_view_view here.
    if (force_reload === undefined) {
        force_reload = false;
    }

    if (did_any_change([Keys.DATA_ASSETS,
        Keys.KEY_DATA_ALL_ATTACHMENTS,
        Keys.KEY_MENU_ATTACHMENTS_SELECTED,
        Keys.DATA_WORKORDERS,
        Keys.MENU_WORKORDERS_SELECTED,
        Keys.DATA_ASSETS,
        Keys.MENU_ASSETS_SELECTED,
        Keys.DATA_FINDINGS,
        Keys.MENU_FINDINGS_SELECTED,
        Keys.ID_DRAWING,
        Keys.ENABLED_FEATURE_CLUSTER,
        Keys.DATA_READINGS,
        Keys.DATA_ASSETS_JSON])) {
        force_reload = true;
    }

    if (force_reload) {
        remove_map_layer(_the_map_features_layer);
        remove_map_layer(_the_lines_layer);

        let state: State = get_state();
        let map_features: MapFeaturesCollection = MapFeaturesCollection.empty;

        if (state.menu_attachments_selected) {
            let atc: AttachmentCollection = state.attachments.get_for_floor(state.id_floor);
            map_features.add_features(atc.as_array);
        }
        if (Configuration.workorders_feature_enabled) {
            const assetsFiltered = get_state().assetsFiltered;
            let wc: WorkordersCollection = state.workorders.get_for_floor(state.id_floor).get_by_categories(state.menu_workorders_selected).get_by_assets(assetsFiltered, state.is_asset_filter_active);

            let WOMapfeature = wc.as_map_feature_array;
            map_features.add_features(WOMapfeature);
        }
        if (Configuration.assets_feature_enabled) {
            const assetsFiltered = get_state().assetsFiltered;
            let ac: AssetCollection = state.assets.get_assets_on_floor(state.id_floor, assetsFiltered, state.is_asset_filter_active).get_assets_by_categories(state.menu_asset_categories_selected, assetsFiltered);
            map_features.add_features(ac.as_array);
        }
        if (Configuration.findings_feature_enabled) {
            let fc: FindingCollection = state.findings.get_on_floor(state.id_floor).get_findings_by_categories(state.menu_finding_categories_selected);
            map_features.add_features(fc.as_array);
        } 
        let drawing: Drawing = state.drawing;
        if (drawing === null) {
            // state.id_drawing points at a drawing that isn't in all_drawings at this instant -
            // e.g. a background floorplan-data update raced with a drawing switch. Skip this
            // redraw rather than crash; the next state change (once id_drawing/all_drawings are
            // back in sync) will trigger a correct redraw.
            console.debug(`map_redraw_layers: state.drawing is null for id_drawing ${state.id_drawing}, skipping redraw`);
            on_resolution_changed();
            return;
        }
        map_features.translate(drawing, get_state().enabled_feature_decluster);

        let ol_map_features:any[] = [];
        map_features.as_array.forEach((mf:MapFeature)=>{
            ol_map_features.push(mf.createOpenlayersFeature(drawing.p0));
        });
        _clustered_features_layer = _make_clustered_layer(ol_map_features);
        _unclustered_features_layer = _make_unclustered_layer(ol_map_features);
        _the_lines_layer = _make_line_layer(map_features);

    }
    on_resolution_changed();
}


export function map_area_on_click(e: any) {

    let state: State = get_state();
    if (state.get_boolean(Keys.STATE_CREATING_ASSET) == true) {
        return;  // We are in an add feature state. Do nothing on single click and add a feature on double click.
    }
    if (state.get_boolean(Keys.STATE_CREATING_WORKORDER) == true) {
        return;  // We are in an add feature state. Do nothing on single click and add a feature on double click.
    }

    let feature: any = _the_map.forEachFeatureAtPixel(e.pixel, function (feature: any, layer: any) {
        if (feature.data !== undefined) {
            return feature;
        }
        if (feature.getProperties !== undefined) {
            let properties = feature.getProperties();
            if (properties.features.length == 1) {
                return properties.features[0];
            }
        }
    });

    if (!feature) {
        return;  // no feature was found
    }

    // All featured that can be opened up and edited contain a data field.
    if (feature.data) {
        var data = feature.data;
        var feature_type = data.feature;
        if (!feature_type) {
            console.error("the map feature.data field is missing the required feature field");
        }

        if (feature_type === "asset") {
            var id_asset = data.id_asset;
            var raw_asset = get_state().assets.get_asset(Id_asset.wrap(id_asset)).raw;
            raw_asset.featureType = "editAsset";
            parent.postMessage(raw_asset, "*");
            if (get_state().is_debug) {
                console.error(JSON.stringify(raw_asset.raw, null, 2));
            }
            return;
        }

        if (feature_type === "finding") {
            var id_finding = data.id_finding;
            var raw_finding = get_state().findings.get_finding(Id_finding.wrap(id_finding)).raw;

            parent.postMessage(raw_finding, "*");
            if (get_state().is_debug) {
                console.error(JSON.stringify(raw_finding, null, 2));
            }
            return;
        }
        if (feature_type === "attachment") {
            AttachmentUi.attachment_clicked(state.imm_state, data, data.icon, null);
            (window as any).__temp_update_attachment = {};
            (window as any).__temp_update_attachment.url = data.url;
            (window as any).__temp_update_attachment.original_coords = data.coords;
            return;
        }
        if (feature_type === "workorder") {
            // open the edit form for the work order
            var id_workorder = data.id;
            let wo: Workorder = get_state().workorders.get_workorder(Id_workorder.wrap(id_workorder));

            var raw_workorder = wo.raw;
            raw_workorder.featureType = "editWorkOrder";
            parent.postMessage(raw_workorder, "*");
            if (get_state().is_debug) {
                console.error(JSON.stringify(raw_workorder, null, 2));
            }
            return;
        }

        if (feature_type === "multi-asset-workorder"){
            let wo:Workorder = get_state().workorders.get_workorder(Id_workorder.wrap(data.id_workorder));
            var raw: any = {};
            raw["id_asset"] = data.id_asset;
            raw["id_workorder_asset"] = data.id_workorder_asset;
            raw["id_workorder"] = data.id_workorder;
            raw["raw"] = wo.raw;

            parent.postMessage(raw, "*");
            if (get_state().is_debug) {
                console.error(JSON.stringify(raw, null, 2));
            }
            return;
        }

        console.error("the selected map feature is not an asset or a work order");
        return;
    }
    else {
        console.error("feature doesn't have a raw CMS data");
    }
}
